import type {Expand} from '../types';

export const rewardProfileExpandCommon: Expand = {
  reward_profile: ['tier_id', ['next_tier_id->nextTier', null]],
};
